import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" data-testid="forgot-password-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">Reset your password</h1>
            <p className="auth-subtitle">
              Enter the email associated with your MedCare Training Academy account and we'll send you a link to choose a new password.
            </p>
          </div>

          {submitted ? (
            <div
              className="alert"
              data-testid="forgot-password-success"
              style={{
                background: '#dcfce7',
                border: '1px solid #86efac',
                color: '#166534',
                padding: 16,
                borderRadius: 8,
              }}
            >
              <p style={{ margin: 0, fontWeight: 600 }}>Check your email.</p>
              <p style={{ marginTop: 6, fontSize: '0.9rem' }}>
                If an account exists for <strong>{email}</strong>, we just sent a password reset link.
                The link expires in 24 hours. If you don't see it, check your spam folder or contact
                administration at 901.625.1201.
              </p>
            </div>
          ) : (
            <>
              {error && (
                <div className="alert alert-error" data-testid="forgot-password-error">
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-input"
                    placeholder="you@example.com"
                    required
                    data-testid="forgot-password-email-input"
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary btn-lg"
                  style={{ width: '100%' }}
                  disabled={loading}
                  data-testid="forgot-password-submit-btn"
                >
                  {loading ? 'Sending reset link…' : 'Send reset link'}
                </button>
              </form>
            </>
          )}

          <div className="auth-footer" style={{ marginTop: 20 }}>
            Remembered it? <Link to="/login" data-testid="back-to-login-link">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
